
import { DataTypeEnum } from "../../../common/enums/DataTypeEnum";
import { DateRangeType } from "../../../common/enums/DRCXEnums";
import { SetPointTypeEnum } from "../../../common/enums/SetpointTypeEnum";
import { SetPointVarianceTimeframeEnum } from "../../../common/enums/SetpointVarianceTimeframeEnum";
import { SetPointVarianceTypeEnum } from "../../../common/enums/SetpointVarianceTypeEnum";
import i18n from "../../../services/localization-service/i18n";
import { IReferenceUnitOfMeasureDTO, SetPointPrecedenceTypeEnum } from "../../../services/setpoint-administration-service/Models";
import { SetpointFormType } from "../AlarmSetpointEditorUtils";

export type LogicSummary = {
    alarmText: string;
    clearText: string;
}


const AlarmSetpointSummaryUtils = {
 
    actionSummary: (setpoint: SetpointFormType): string => {

        return !setpoint.notifyOnAlarm ?  i18n.t('setpointAdmin.summary.messagingNone') :
             i18n.t('setpointAdmin.summary.messagingSummaryText', {
                    messageType: setpoint.customMessaging ? 'custom messaging' : 'default messaging',
                        option: setpoint.notifyOnAlarm && setpoint.notifyOnNormal ? 
                            'alarms and clears' : 
                        setpoint.notifyOnAlarm ?
                            'alarms' :
                        ''

        });


        // var messagingTypeStatement = !this.setPoint.customMessaging ? "Default Messaging" : "Custom Messaging";

        // var notifOptionsStatement = "";
        // if (this.setPoint.notifyOnAlarm && this.setPoint.notifyOnNormal) {
        //     notifOptionsStatement = "Alarms and Clears"
        // }
        // else if (this.setPoint.notifyOnAlarm && !this.setPoint.notifyOnNormal) {
        //     notifOptionsStatement = "Alarms"
        // }
        // else {
        //     notifOptionsStatement = "nothing"
        // }

        // this._messagingSummaryText = Utilities.StringFormat(
        //     i18n.t("setPointAdmin.addEditDialog.summaryTab.messagingSummaryText"),
        //     messagingTypeStatement,
        //     notifOptionsStatement
        // );        
    }, 
    logicSummary: (setpoint: SetpointFormType, uoms: IReferenceUnitOfMeasureDTO[]) : LogicSummary => {

        let uom = uoms.find(o => o.id === setpoint.unitOfMeasureID)?.name ?? '';
        if (uom.toLowerCase() === 'undefined') {
            uom = '';
        }

        let alarmText = '';
        let clearText = '';

        // Time comparison setpoints are available for double and text data types
        if(setpoint.comparisonType === SetPointTypeEnum.TimeComparison) {
            const timespanType = setpoint.timespanType === DateRangeType.Minute
                ? i18n.t("setpointAdmin.timeComparisonTimeSpan.minutes")
                : setpoint.timespanType === DateRangeType.Hour
                    ? i18n.t("setpointAdmin.timeComparisonTimeSpan.hours")
                    : setpoint.timespanType === DateRangeType.Day
                        ? i18n.t("setpointAdmin.timeComparisonTimeSpan.days")
                        : "";
            
            alarmText = i18n.t("setpointAdmin.summary.alarmTimeComparisonTriggerMessage", {
                operator: setpoint.operator,
                value: setpoint.value,
                timespanType: timespanType
            });

            clearText = i18n.t("setpointAdmin.summary.alarmTimeComparisonClearMessage", {
                operator: setpoint.operator,
                value: setpoint.value,
                timespanType: timespanType
            });
        } else if (setpoint.dataType === DataTypeEnum.Double) {

            if (setpoint.isDiscrete || setpoint.setPointType === SetPointPrecedenceTypeEnum.Field) {
                alarmText = i18n.t("setpointAdmin.summary.fieldAlarmTrigger");
                clearText = i18n.t("setpointAdmin.summary.fieldAlarmClear")

            } else {

                let varianceType = "";
                let varianceWindow = "";

                if (setpoint.comparisonType !== SetPointTypeEnum.ValueComparison) {

                    switch (setpoint.varianceType) {

                        case SetPointVarianceTypeEnum.Decrease:
                            varianceType = i18n.t("setpointAdmin.varianceType.decrease");
                            break;

                        case SetPointVarianceTypeEnum.Increase:
                            varianceType = i18n.t("setpointAdmin.varianceType.increase");
                            break;

                        case SetPointVarianceTypeEnum.Either:
                            varianceType = i18n.t("setpointAdmin.varianceType.either");
                            break;

                    }

                    switch (setpoint.varianceTimeframeType) {
                        case SetPointVarianceTimeframeEnum.Days:
                            varianceWindow = `${setpoint.varianceWindow} ${i18n.t(setpoint.varianceWindow === 1 ? "setpointAdmin.varianceTimeframe.day" : "setpointAdmin.varianceTimeframe.days")}`;
                            break;

                        case SetPointVarianceTimeframeEnum.Hours:
                            varianceWindow = `${setpoint.varianceWindow} ${i18n.t(setpoint.varianceWindow === 1 ? "setpointAdmin.varianceTimeframe.hour" : "setpointAdmin.varianceTimeframe.hours")}`;
                            break;

                        case SetPointVarianceTimeframeEnum.Months:
                            varianceWindow = `${setpoint.varianceWindow} ${i18n.t(setpoint.varianceWindow === 1 ? "setpointAdmin.varianceTimeframe.month" : "setpointAdmin.varianceTimeframe.months")}`;
                            break;
                    }
                }

                switch(setpoint.comparisonType) {
                    case SetPointTypeEnum.ValueComparison: {

                        const operator = setpoint.operator === '<' ? 
                            i18n.t("setpointAdmin.summary.less") :
                            setpoint.operator === '>' ?
                            i18n.t("setpointAdmin.summary.greater") :
                            setpoint.operator === '=' ?
                            i18n.t("setpointAdmin.summary.equal") :
                            i18n.t("setpointAdmin.summary.notequal"); 


                        alarmText = i18n.t("setpointAdmin.summary.alarmValueComparisonTriggerMessage", {
                            operator: operator,
                            value: setpoint.value.toString(),
                            uom: uom
                        });
                            // Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.valueComparisonOperator).name,
                            // this.setPoint.valueComparisonValue,
                            // Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id == this.setPoint.valueComparisonUnitOfMeasureID).name);

                        clearText = i18n.t(setpoint.operator === '=' ?
                                        "setpointAdmin.summary.alarmValueComparisonEqualToClearMessage" :
                                        "setpointAdmin.summary.alarmValueComparisonClearMessage", {
                            value: setpoint.value.toString(),
                            uom: uom
                        });                  

                        // this._alarmClearText = Utilities.StringFormat(
                        //     i18n.t("setPointAdmin.addEditDialog.logicTab.alarmValueComparisonClearMessage"), this.setPoint.valueComparisonValue,
                        //     Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id == this.setPoint.valueComparisonUnitOfMeasureID).name);

                        if (setpoint.operator === '<') {
                            clearText += i18n.t("setpointAdmin.summary.orgreater");
                        } else if (setpoint.operator === '>') {
                            clearText += i18n.t("setpointAdmin.summary.orless");
                        }


                        // if (this.setPoint.valueComparisonOperator == 1) {
                        //     this._alarmClearText = this._alarmClearText + " or less."
                        // }
                        // else if (this.setPoint.valueComparisonOperator == 2) {
                        //     this._alarmClearText = this._alarmClearText + " or greater."
                        // }
                        // else if (this.setPoint.valueComparisonOperator == 4) {
                        //     this._alarmClearText = Utilities.StringFormat(
                        //         i18n.t("setPointAdmin.addEditDialog.logicTab.alarmValueComparisonEqualToClearMessage"), this.setPoint.valueComparisonValue,
                        //         Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id == this.setPoint.valueComparisonUnitOfMeasureID).name);
                        // }
                    }
                        break;

                    case SetPointTypeEnum.VariationAmount: {
                        const varianceOperator = setpoint.operator === '>' ? 'more than' : 'less than';


                        alarmText = i18n.t("setpointAdmin.summary.alarmVariationAmountTriggerMessage", {
                            varianceType: varianceType,
                            varianceWindow: varianceWindow,
                            varianceOperator: varianceOperator,
                            varianceValue: setpoint.value,
                            uom: uom
                        });

                        clearText = i18n.t("setpointAdmin.summary.alarmVariationAmountClearMessage", {
                            varianceType: varianceType,
                            varianceWindow: varianceWindow,
                            varianceOperator: varianceOperator,
                            varianceValue: setpoint.value,
                            uom: uom
                        });



                        // this._alarmTriggerText = Utilities.StringFormat(
                        //     i18n.t("setPointAdmin.addEditDialog.logicTab.alarmVariationAmountTriggerMessage"),
                        //     Enumerable.from(this.varianceTypes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonType).name,
                        //     this.setPoint.varianceComparisonWindow,
                        //     Enumerable.from(this.varianceTimeframes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonTimeframeType).name,
                        //     Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.varianceComparisonOperator).name,
                        //     this.setPoint.varianceComparisonValue,
                        //     Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id == this.setPoint.varianceComparisonUnitOfMeasureID).name);

                        // this._alarmClearText = Utilities.StringFormat(
                        //     i18n.t("setPointAdmin.addEditDialog.logicTab.alarmVariationAmountClearMessage"),
                        //     Enumerable.from(this.varianceTypes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonType).name,
                        //     this.setPoint.varianceComparisonWindow,
                        //     Enumerable.from(this.varianceTimeframes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonTimeframeType).name,
                        //     Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.varianceComparisonOperator).name,
                        //     this.setPoint.varianceComparisonValue,
                        //     Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id ==  this.setPoint.varianceComparisonUnitOfMeasureID).name);

                    }
                        break;

                    case SetPointTypeEnum.VariationPercent: {

                        //const operator = setpoint.operator === '>' ? 'less than' :  operators.find(o => o.Value === setpoint.operator)?.Key;
                        //const operator = operators.find(o => o.Value === setpoint.operator)?.Key;
                        const varianceOperator = setpoint.operator === '>' ? 'more than' : 'less than';

                        alarmText = i18n.t("setpointAdmin.summary.alarmVariationPercentTriggerMessage", {
                            varianceType: varianceType,
                            varianceWindow: varianceWindow,
                            varianceOperator: varianceOperator,
                            varianceValue: setpoint.value
                        });

                        clearText = i18n.t("setpointAdmin.summary.alarmVariationPercentClearMessage", {
                            varianceType: varianceType,
                            varianceWindow: varianceWindow,
                            varianceOperator: varianceOperator,
                            varianceValue: setpoint.value
                        });
                    }

                    // this._alarmTriggerText = Utilities.StringFormat(
                    //     i18n.t("setPointAdmin.addEditDialog.logicTab.alarmVariationPercentTriggerMessage"),
                    //     Enumerable.from(this.varianceTypes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonType).name,
                    //     this.setPoint.varianceComparisonWindow,
                    //     Enumerable.from(this.varianceTimeframes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonTimeframeType).name,
                    //     Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.varianceComparisonOperator).name,
                    //     this.setPoint.varianceComparisonValue);

                    // this._alarmClearText = Utilities.StringFormat(
                    //     i18n.t("setPointAdmin.addEditDialog.logicTab.alarmVariationPercentClearMessage"),
                    //     Enumerable.from(this.varianceTypes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonType).name,
                    //     this.setPoint.varianceComparisonWindow,
                    //     Enumerable.from(this.varianceTimeframes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonTimeframeType).name,
                    //     Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.varianceComparisonOperator).name,
                    //     this.setPoint.varianceComparisonValue);

                        break;
                    default:
                        break;

                }
            }

        } else {




            switch(setpoint.operator) {
                case 'contains':

                    alarmText = i18n.t("setpointAdmin.summary.textAlarmTrigger", {
                        operator: 'contains',
                        value: setpoint.textValue
                    });

                    clearText = i18n.t("setpointAdmin.summary.textAlarmClear", {
                        operator: 'does not contain',
                        value: setpoint.textValue
                    });

                    break;

                case 'does not contain':
                    alarmText = i18n.t("setpointAdmin.summary.textAlarmTrigger", {
                        operator: 'does not contain',
                        value: setpoint.textValue
                    });

                    clearText = i18n.t("setpointAdmin.summary.textAlarmClear", {
                        operator: 'contains',
                        value: setpoint.textValue
                    });

                    break;

                case 'exactly matches':
                    alarmText = i18n.t("setpointAdmin.summary.textAlarmTrigger", {
                        operator: 'exactly matches',
                        value: setpoint.textValue
                    });

                    clearText = i18n.t("setpointAdmin.summary.textAlarmClear", {
                        operator: 'does not exactly match',
                        value: setpoint.textValue
                    });

                    break;

                case 'does not exactly match':
                    alarmText = i18n.t("setpointAdmin.summary.textAlarmTrigger", {
                        operator: 'does not exactly match',
                        value: setpoint.textValue
                    });

                    clearText = i18n.t("setpointAdmin.summary.textAlarmClear", {
                        operator: 'exactly matches',
                        value: setpoint.textValue
                    });

                    break;

                case 'begins with':
                    alarmText = i18n.t("setpointAdmin.summary.textAlarmTrigger", {
                        operator: 'begins with',
                        value: setpoint.textValue
                    });

                    clearText = i18n.t("setpointAdmin.summary.textAlarmClear", {
                        operator: 'does not begin with',
                        value: setpoint.textValue
                    });

                    break;

                case 'ends with':
                    alarmText = i18n.t("setpointAdmin.summary.textAlarmTrigger", {
                        operator: 'ends with',
                        value: setpoint.textValue
                    });

                    clearText = i18n.t("setpointAdmin.summary.textAlarmClear", {
                        operator: 'does not end with',
                        value: setpoint.textValue
                    });

                    break;
            }
        }

        return {
            alarmText,
            clearText
        };
    }
}

export default AlarmSetpointSummaryUtils;

























// public logicSummaryStatements = () => {

//     if (this.setPoint.dataType == Enums.DataTypeEnum.Double) {
//         switch (this.setPoint.comparisonType) {
//             case (Enums.SetPointTypeEnum.ValueComparison):
//                 {
//                     this._alarmTriggerText = Utilities.StringFormat(
//                         i18n.t("setPointAdmin.addEditDialog.logicTab.alarmValueComparisonTriggerMessage"),
//                         Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.valueComparisonOperator).name,
//                         this.setPoint.valueComparisonValue,
//                         Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id == this.setPoint.valueComparisonUnitOfMeasureID).name);

//                     this._alarmClearText = Utilities.StringFormat(
//                         i18n.t("setPointAdmin.addEditDialog.logicTab.alarmValueComparisonClearMessage"), this.setPoint.valueComparisonValue,
//                         Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id == this.setPoint.valueComparisonUnitOfMeasureID).name);

//                     if (this.setPoint.valueComparisonOperator == 1) {
//                         this._alarmClearText = this._alarmClearText + " or less."
//                     }
//                     else if (this.setPoint.valueComparisonOperator == 2) {
//                         this._alarmClearText = this._alarmClearText + " or greater."
//                     }
//                     else if (this.setPoint.valueComparisonOperator == 4) {
//                         this._alarmClearText = Utilities.StringFormat(
//                             i18n.t("setPointAdmin.addEditDialog.logicTab.alarmValueComparisonEqualToClearMessage"), this.setPoint.valueComparisonValue,
//                             Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id == this.setPoint.valueComparisonUnitOfMeasureID).name);
//                     }
//                 }
//                 break;

//             case (Enums.SetPointTypeEnum.VariationPercent):
//                 {
//                     this._alarmTriggerText = Utilities.StringFormat(
//                         i18n.t("setPointAdmin.addEditDialog.logicTab.alarmVariationPercentTriggerMessage"),
//                         Enumerable.from(this.varianceTypes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonType).name,
//                         this.setPoint.varianceComparisonWindow,
//                         Enumerable.from(this.varianceTimeframes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonTimeframeType).name,
//                         Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.varianceComparisonOperator).name,
//                         this.setPoint.varianceComparisonValue);

//                     this._alarmClearText = Utilities.StringFormat(
//                         i18n.t("setPointAdmin.addEditDialog.logicTab.alarmVariationPercentClearMessage"),
//                         Enumerable.from(this.varianceTypes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonType).name,
//                         this.setPoint.varianceComparisonWindow,
//                         Enumerable.from(this.varianceTimeframes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonTimeframeType).name,
//                         Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.varianceComparisonOperator).name,
//                         this.setPoint.varianceComparisonValue);
//                 }
//                 break;

//             case (Enums.SetPointTypeEnum.VariationAmount):
//                 {
//                     this._alarmTriggerText = Utilities.StringFormat(
//                         i18n.t("setPointAdmin.addEditDialog.logicTab.alarmVariationAmountTriggerMessage"),
//                         Enumerable.from(this.varianceTypes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonType).name,
//                         this.setPoint.varianceComparisonWindow,
//                         Enumerable.from(this.varianceTimeframes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonTimeframeType).name,
//                         Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.varianceComparisonOperator).name,
//                         this.setPoint.varianceComparisonValue,
//                         Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id == this.setPoint.varianceComparisonUnitOfMeasureID).name);

//                     this._alarmClearText = Utilities.StringFormat(
//                         i18n.t("setPointAdmin.addEditDialog.logicTab.alarmVariationAmountClearMessage"),
//                         Enumerable.from(this.varianceTypes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonType).name,
//                         this.setPoint.varianceComparisonWindow,
//                         Enumerable.from(this.varianceTimeframes).firstOrDefault(x => x.id == this.setPoint.varianceComparisonTimeframeType).name,
//                         Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.varianceComparisonOperator).name,
//                         this.setPoint.varianceComparisonValue,
//                         Enumerable.from(this.unitsOfMeasure).firstOrDefault(x => x.id ==  this.setPoint.varianceComparisonUnitOfMeasureID).name);
//                 }
//                 break;
//         }
//     }
//     else if (this.setPoint.dataType == Enums.DataTypeEnum.String) {

//         switch (this.setPoint.textValueComparisonOperator) {
//             case (SetPointAdministrationModels.EditModel.OPERATOR_CONTAINS):
//                 {
//                     this._alarmTriggerText = Utilities.StringFormat(
//                       i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmTrigger"),
//                       Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.textValueComparisonOperator).name,
//                       this.setPoint.textValueComparisonValue)

//                     this._alarmClearText = Utilities.StringFormat(
//                       i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmClear"), i18n.t("enums.setPointOperator.doesNotContain"),
//                       this.setPoint.textValueComparisonValue)
//                 }
//                 break;

//            case (SetPointAdministrationModels.EditModel.OPERATOR_DOES_NOT_CONTAIN):
//                 {
//                     this._alarmTriggerText = Utilities.StringFormat(
//                       i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmTrigger"),
//                       Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.textValueComparisonOperator).name,
//                       this.setPoint.textValueComparisonValue)

//                     this._alarmClearText = Utilities.StringFormat(
//                       i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmClear"), i18n.t("enums.setPointOperator.contains"),
//                       this.setPoint.textValueComparisonValue)
//                 }
//                 break;

//            case (SetPointAdministrationModels.EditModel.OPERATOR_EXACTLY_MATCHES):
//                 {
//                     this._alarmTriggerText = Utilities.StringFormat(
//                       i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmTrigger"),
//                       Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.textValueComparisonOperator).name,
//                       this.setPoint.textValueComparisonValue)

//                     this._alarmClearText = Utilities.StringFormat(
//                       i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmClear"), i18n.t("enums.setPointOperator.doesNotExactlyMatch"),
//                       this.setPoint.textValueComparisonValue)
//                 }
//                 break;

//           case (SetPointAdministrationModels.EditModel.OPERATOR_DOES_NOT_EXACTLY_MATCH):
//                 {
//                     this._alarmTriggerText = Utilities.StringFormat(
//                       i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmTrigger"),
//                       Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.textValueComparisonOperator).name,
//                       this.setPoint.textValueComparisonValue)

//                     this._alarmClearText = Utilities.StringFormat(
//                       i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmClear"), i18n.t("enums.setPointOperator.exactlyMatches"),
//                       this.setPoint.textValueComparisonValue)
//                 }
//                 break;

//           case (SetPointAdministrationModels.EditModel.OPERATOR_BEGINS_WITH):
//                {
//                    this._alarmTriggerText = Utilities.StringFormat(
//                      i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmTrigger"),
//                      Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.textValueComparisonOperator).name,
//                      this.setPoint.textValueComparisonValue)

//                    this._alarmClearText = Utilities.StringFormat(
//                      i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmClear"), " does not begin with",
//                      this.setPoint.textValueComparisonValue)
//                }
//                break;

//           case (SetPointAdministrationModels.EditModel.OPERATOR_ENDS_WITH):
//              {
//                  this._alarmTriggerText = Utilities.StringFormat(
//                    i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmTrigger"),
//                    Enumerable.from(this.operators).firstOrDefault(x => x.id == this.setPoint.textValueComparisonOperator).name,
//                    this.setPoint.textValueComparisonValue)

//                  this._alarmClearText = Utilities.StringFormat(
//                    i18n.t("setPointAdmin.addEditDialog.logicTab.textAlarmClear"), " does not end with",
//                    this.setPoint.textValueComparisonValue)
//              }
//              break;
//         }

//     }
    
// }

